import ControlPanel from "./control-panel";

export default ControlPanel;